import type { ApplicationConfig } from './ApplicationConfig';
import { Stage } from './ApplicationConfig';

export const stagingConfig: ApplicationConfig = {
  apiUrl: 'https://staging-api.skin-seoul.com',
  apiKey: '75dd554a-2b38-4774-807d-a3d1a870c9e7',
  stage: Stage.STAGING,
  sheetId: '16-wNHHRraJvvOdEG41IdOavPS7TMYwj8d4T0RHKtnFE',
  wpAdminUrl: 'https://staging.skin-seoul.com/wp-admin/',
  adminUrl: 'https://staging-admin.skin-seoul.work',
};
